export const TOAST_STYLE = {
  position: "fixed",
  top: 10,
  right: 10,
  zIndex: 1000,
  padding: "10px",
  borderRadius: 4,
  boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
};
